export enum Category {
  All = "All",
  Recognition = "Recognition",
  Synthesis = "Synthesis",
  Translate = "Translate",
}